import { AspectRatio, Box, Flex, Stack, Wrap, WrapItem, useBreakpointValue } from '@chakra-ui/react';
import ButtonLink from '~/components/ButtonLink';
import CarouselChild from '~/components/Carousel/CarouselChild';
import CarouselContainer from '~/components/Carousel/CarouselContainer';
import Hero from '~/components/Hero';
import HtmlParser from '~/components/HtmlParser/HtmlParser';
import Image from '~/components/Image';
import Layout from '~/components/Layout';
import ProgramTabs from '~/components/ProgramTabs';
import ProgramThumbnail from '~/components/ProgramThumbnail';
import SectionWithTitle from '~/components/SectionWithTitle';
import SEO from '~/components/SEO';
import AgeIcon from '~/components/SVG/AgeIcon';
import CalendarIcon from '~/components/SVG/CalendarIcon';
import PriceIcon from '~/components/SVG/PriceIcon';
import TestimonialsSection from '~/components/TestimonialsSection';
import Text from '~/components/Text';
import { getCurrentOrigin } from '~/utils/getCurrentDomain';
import { getSeoDataFromWordpressForPage } from '~/utils/getSeoData';
import { createImageWithArtDirection } from '~/utils/imageUtils';
import React from 'react';
import renderEdvisorSearchModal from '../components/Edvisor/renderEdvisorSearchModal';

var ProgrammeTemplate = function ProgrammeTemplate(props) {
  var _contentTypeData$lang, _acfData$heroProgram, _acfData$heroProgram$, _acfData$heroProgram$2, _acfData$heroProgram$3, _acfData$heroProgram$4, _acfData$heroProgram2, _acfData$heroProgram3, _acfData$introduction, _acfData$introduction2, _acfData$introduction3, _acfData$introduction4, _acfData$introduction5, _acfData$introduction6, _acfData$introduction7, _pageTemplateData$acf, _pageTemplateData$acf2, _pageTemplateData$acf3, _acfData$informations, _acfData$informations2, _acfData$informations3, _acfData$informations4, _acfData$informations5, _acfData$attributes, _acfData$attributes$c, _acfData$attributes$c2, _acfData$attributes2, _acfData$attributes2$, _acfData$attributes2$2, _acfData$attributes2$3, _acfData$attributes2$4, _acfData$attributes3, _acfData$attributes3$, _acfData$attributes3$2, _acfData$attributes4, _acfData$attributes4$, _acfData$attributes4$2, _acfData$attributes4$3, _acfData$attributes4$4, _acfData$attributes5, _acfData$attributes5$, _acfData$attributes5$2, _acfData$attributes6, _pageTemplateData$acf4, _pageTemplateData$acf5, _acfData$gallery, _acfData$gallery$yout, _acfData$gallery2, _acfData$gallery2$med, _acfData$gallery3, _acfData$gallery3$med, _acfData$gallery4, _acfData$gallery4$you, _acfData$gallery5, _acfData$gallery5$you, _pageTemplateData$acf6, _pageTemplateData$acf7, _pageTemplateData$acf8, _pageTemplateData$acf9, _pageTemplateData$acf10, _pageTemplateData$acf11, _pageTemplateData$acf12, _acfData$relatedProgr, _pageTemplateData$acf13, _pageTemplateData$acf14, _pageTemplateData$acf15, _pageTemplateData$acf16, _acfData$introduction8, _contentTypeData$acfP, _contentTypeData$acfP2, _pageTemplateData$acf17, _pageTemplateData$acf18, _contentTypeData$acfP3;

  var data = props.data;
  var pageContext = props.pageContext;
  var contentTypeData = data.wpProgramme;
  var pageTemplateData = data.wpPageTemplate;
  var acfData = contentTypeData === null || contentTypeData === void 0 ? void 0 : contentTypeData.acfProgram;
  if (!contentTypeData || !pageTemplateData || !acfData || !(contentTypeData !== null && contentTypeData !== void 0 && contentTypeData.link) || !pageContext.defaultLanguage) return null;
  var seoProps = getSeoDataFromWordpressForPage({
    availableTranslations: contentTypeData.translations,
    currentLanguage: (_contentTypeData$lang = contentTypeData.language) === null || _contentTypeData$lang === void 0 ? void 0 : _contentTypeData$lang.locale,
    currentOrigin: getCurrentOrigin(),
    defaultLanguage: pageContext.defaultLanguage,
    featuredImageUrl: (_acfData$heroProgram = acfData.heroProgram) === null || _acfData$heroProgram === void 0 ? void 0 : (_acfData$heroProgram$ = _acfData$heroProgram.desktopFeaturedImage) === null || _acfData$heroProgram$ === void 0 ? void 0 : (_acfData$heroProgram$2 = _acfData$heroProgram$.localFile) === null || _acfData$heroProgram$2 === void 0 ? void 0 : (_acfData$heroProgram$3 = _acfData$heroProgram$2.childImageSharp) === null || _acfData$heroProgram$3 === void 0 ? void 0 : (_acfData$heroProgram$4 = _acfData$heroProgram$3.gatsbyImageData) === null || _acfData$heroProgram$4 === void 0 ? void 0 : _acfData$heroProgram$4.src,
    pagePath: props.location.pathname,
    pageSlug: contentTypeData.slug,
    seo: contentTypeData.seo
  });
  var imageWithArtDirection = createImageWithArtDirection({
    desktopImage: (_acfData$heroProgram2 = acfData.heroProgram) === null || _acfData$heroProgram2 === void 0 ? void 0 : _acfData$heroProgram2.desktopFeaturedImage,
    mobileImage: (_acfData$heroProgram3 = acfData.heroProgram) === null || _acfData$heroProgram3 === void 0 ? void 0 : _acfData$heroProgram3.mobileFeaturedImage
  });
  var agePictoTemplateText = 'Dès {{AGE}} ans';
  var calendarPictoText = {
    '8weeks': 'De 1 à 8 semaines',
    trimester: 'Tout un trimestre',
    year: "Toute l'année"
  };
  var durationKey = (_acfData$introduction = acfData.introduction) === null || _acfData$introduction === void 0 ? void 0 : (_acfData$introduction2 = _acfData$introduction.pictos) === null || _acfData$introduction2 === void 0 ? void 0 : _acfData$introduction2.calendarPictoText;
  var introductionSection = /*#__PURE__*/React.createElement(SectionWithTitle, null, /*#__PURE__*/React.createElement(Stack, {
    direction: {
      base: 'column',
      sm: 'row'
    },
    justify: "center",
    align: "center",
    spacing: {
      base: 8,
      lg: 12
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    width: {
      base: 250,
      sm: 125,
      '2xl': 150
    },
    align: "center",
    textAlign: "center",
    spacing: 4
  }, /*#__PURE__*/React.createElement(AgeIcon, {
    width: useBreakpointValue({
      base: 75,
      sm: 75,
      lg: 100,
      xl: 120
    }),
    height: useBreakpointValue({
      base: 75,
      sm: 75,
      lg: 100,
      xl: 120
    })
  }), /*#__PURE__*/React.createElement(Text, null, agePictoTemplateText.replace('{{AGE}}', (_acfData$introduction3 = (_acfData$introduction4 = acfData.introduction) === null || _acfData$introduction4 === void 0 ? void 0 : (_acfData$introduction5 = _acfData$introduction4.pictos) === null || _acfData$introduction5 === void 0 ? void 0 : _acfData$introduction5.agePictoText) !== null && _acfData$introduction3 !== void 0 ? _acfData$introduction3 : ''))), /*#__PURE__*/React.createElement(Stack, {
    width: {
      base: 250,
      sm: 150
    },
    align: "center",
    textAlign: "center",
    spacing: 4
  }, /*#__PURE__*/React.createElement(CalendarIcon, {
    width: useBreakpointValue({
      base: 75,
      sm: 75,
      lg: 100,
      xl: 120
    }),
    height: useBreakpointValue({
      base: 75,
      sm: 75,
      lg: 100,
      xl: 120
    })
  }), /*#__PURE__*/React.createElement(Text, null, calendarPictoText[durationKey])), /*#__PURE__*/React.createElement(Stack, {
    width: {
      base: 250,
      sm: 150
    },
    align: "center",
    textAlign: "center",
    spacing: 4
  }, /*#__PURE__*/React.createElement(PriceIcon, {
    width: useBreakpointValue({
      base: 75,
      sm: 75,
      lg: 100,
      xl: 120
    }),
    height: useBreakpointValue({
      base: 75,
      sm: 75,
      lg: 100,
      xl: 120
    })
  }), /*#__PURE__*/React.createElement(Text, null, "\xC0pd. " + ((_acfData$introduction6 = acfData.introduction) === null || _acfData$introduction6 === void 0 ? void 0 : (_acfData$introduction7 = _acfData$introduction6.pictos) === null || _acfData$introduction7 === void 0 ? void 0 : _acfData$introduction7.pricePictoText)))), /*#__PURE__*/React.createElement(Wrap, null, pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf = pageTemplateData.acfProgramTemplate) === null || _pageTemplateData$acf === void 0 ? void 0 : (_pageTemplateData$acf2 = _pageTemplateData$acf.introductionSection) === null || _pageTemplateData$acf2 === void 0 ? void 0 : (_pageTemplateData$acf3 = _pageTemplateData$acf2.ctas) === null || _pageTemplateData$acf3 === void 0 ? void 0 : _pageTemplateData$acf3.map(function (cta) {
    var _cta$cta, _cta$cta3;

    if ((cta === null || cta === void 0 ? void 0 : (_cta$cta = cta.cta) === null || _cta$cta === void 0 ? void 0 : _cta$cta.id) === 'edvisor') {
      var _cta$cta2;

      if (!acfData.contactBooking) return null;

      var onClick = function onClick() {
        var _acfData$edvisor, _acfData$edvisor2, _acfData$edvisor3;

        return renderEdvisorSearchModal({
          defaultCourseCategoryIds: (_acfData$edvisor = acfData.edvisor) === null || _acfData$edvisor === void 0 ? void 0 : _acfData$edvisor.edvisorPrograms,
          defaultGooglePlaceId: (_acfData$edvisor2 = acfData.edvisor) === null || _acfData$edvisor2 === void 0 ? void 0 : _acfData$edvisor2.googlePlaceId,
          schoolIds: (_acfData$edvisor3 = acfData.edvisor) === null || _acfData$edvisor3 === void 0 ? void 0 : _acfData$edvisor3.edvisorSchoolIds
        });
      };

      return /*#__PURE__*/React.createElement(WrapItem, {
        key: cta === null || cta === void 0 ? void 0 : (_cta$cta2 = cta.cta) === null || _cta$cta2 === void 0 ? void 0 : _cta$cta2.label
      }, /*#__PURE__*/React.createElement(ButtonLink, {
        cta: cta === null || cta === void 0 ? void 0 : cta.cta,
        onClick: onClick,
        "aria-label": "cr\xE9ez votre devis en ligne"
      }));
    }

    return /*#__PURE__*/React.createElement(WrapItem, {
      key: cta === null || cta === void 0 ? void 0 : (_cta$cta3 = cta.cta) === null || _cta$cta3 === void 0 ? void 0 : _cta$cta3.label
    }, /*#__PURE__*/React.createElement(ButtonLink, {
      cta: cta === null || cta === void 0 ? void 0 : cta.cta
    }));
  })), /*#__PURE__*/React.createElement(Box, {
    id: "btWidget"
  }));
  var informationsSection = /*#__PURE__*/React.createElement(SectionWithTitle, {
    width: {
      base: '100%',
      xl: 1200
    },
    spacing: 0,
    fullWidth: {
      base: true,
      xl: false
    },
    mb: "0 !important"
  }, /*#__PURE__*/React.createElement(Flex, {
    wrap: "wrap",
    w: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    width: {
      base: '100%',
      sm: '70%',
      xl: 600
    },
    bg: "blue.600",
    p: {
      base: 4,
      xl: '60px'
    }
  }, /*#__PURE__*/React.createElement(HtmlParser, {
    fontSize: "1.5rem",
    color: "white"
  }, (_acfData$informations = acfData.informations) === null || _acfData$informations === void 0 ? void 0 : _acfData$informations.title), /*#__PURE__*/React.createElement(Text, {
    sx: {
      color: 'white',
      ml: {
        base: 4,
        xl: 58
      },
      mt: 4,
      position: 'relative'
    },
    _before: {
      base: {
        borderLeft: '1px solid white',
        content: '""',
        display: 'block',
        height: '100%',
        left: '-14px',
        position: 'absolute'
      },
      xl: {
        borderLeft: '1px solid white',
        content: '""',
        display: 'block',
        height: 'calc(100% + 60px)',
        left: '-40px',
        position: 'absolute'
      }
    }
  }, (_acfData$informations2 = acfData.informations) === null || _acfData$informations2 === void 0 ? void 0 : _acfData$informations2.description)), /*#__PURE__*/React.createElement(Flex, {
    width: {
      base: '100%',
      sm: '30%',
      xl: 600
    },
    direction: {
      base: 'row',
      sm: 'column',
      xl: 'row'
    },
    wrap: {
      base: 'wrap',
      sm: 'nowrap',
      xl: 'wrap'
    }
  }, (_acfData$informations3 = acfData.informations) === null || _acfData$informations3 === void 0 ? void 0 : (_acfData$informations4 = _acfData$informations3.features) === null || _acfData$informations4 === void 0 ? void 0 : _acfData$informations4.map(function (feature, index) {
    return /*#__PURE__*/React.createElement(Flex, {
      direction: "column",
      textAlign: "center",
      justify: "center",
      align: "center",
      flex: "1 0 50%",
      flexShrink: {
        base: 0,
        sm: 1,
        xl: 0
      },
      height: {
        base: '150px',
        sm: 'auto',
        xl: 'auto'
      },
      p: 3,
      bg: {
        base: index === 1 || index === 2 ? 'primary.500' : 'primary.100',
        sm: index === 0 || index === 2 ? 'primary.500' : 'primary.100',
        xl: index === 1 || index === 2 ? 'primary.500' : 'primary.100'
      },
      key: (feature === null || feature === void 0 ? void 0 : feature.boldWord) + "-" + (feature === null || feature === void 0 ? void 0 : feature.secondLineWord)
    }, /*#__PURE__*/React.createElement(Text, {
      fontWeight: "bold",
      textVariant: "h4"
    }, feature === null || feature === void 0 ? void 0 : feature.boldWord), /*#__PURE__*/React.createElement(Text, {
      textVariant: "h4"
    }, feature === null || feature === void 0 ? void 0 : feature.secondLineWord));
  }))), /*#__PURE__*/React.createElement(ProgramTabs, {
    tabs: (_acfData$informations5 = acfData.informations) === null || _acfData$informations5 === void 0 ? void 0 : _acfData$informations5.tabs,
    city: {
      name: (_acfData$attributes = acfData.attributes) === null || _acfData$attributes === void 0 ? void 0 : (_acfData$attributes$c = _acfData$attributes.city) === null || _acfData$attributes$c === void 0 ? void 0 : (_acfData$attributes$c2 = _acfData$attributes$c[0]) === null || _acfData$attributes$c2 === void 0 ? void 0 : _acfData$attributes$c2.title
    },
    country: {
      name: (_acfData$attributes2 = acfData.attributes) === null || _acfData$attributes2 === void 0 ? void 0 : (_acfData$attributes2$ = _acfData$attributes2.country) === null || _acfData$attributes2$ === void 0 ? void 0 : (_acfData$attributes2$2 = _acfData$attributes2$[0]) === null || _acfData$attributes2$2 === void 0 ? void 0 : (_acfData$attributes2$3 = _acfData$attributes2$2.acfDestination) === null || _acfData$attributes2$3 === void 0 ? void 0 : (_acfData$attributes2$4 = _acfData$attributes2$3.heroDestination) === null || _acfData$attributes2$4 === void 0 ? void 0 : _acfData$attributes2$4.destinationName,
      uri: (_acfData$attributes3 = acfData.attributes) === null || _acfData$attributes3 === void 0 ? void 0 : (_acfData$attributes3$ = _acfData$attributes3.country) === null || _acfData$attributes3$ === void 0 ? void 0 : (_acfData$attributes3$2 = _acfData$attributes3$[0]) === null || _acfData$attributes3$2 === void 0 ? void 0 : _acfData$attributes3$2.uri
    },
    language: {
      shortName: (_acfData$attributes4 = acfData.attributes) === null || _acfData$attributes4 === void 0 ? void 0 : (_acfData$attributes4$ = _acfData$attributes4.language) === null || _acfData$attributes4$ === void 0 ? void 0 : (_acfData$attributes4$2 = _acfData$attributes4$[0]) === null || _acfData$attributes4$2 === void 0 ? void 0 : (_acfData$attributes4$3 = _acfData$attributes4$2.acfLanguage) === null || _acfData$attributes4$3 === void 0 ? void 0 : (_acfData$attributes4$4 = _acfData$attributes4$3.informations) === null || _acfData$attributes4$4 === void 0 ? void 0 : _acfData$attributes4$4.languageNameShort,
      uri: (_acfData$attributes5 = acfData.attributes) === null || _acfData$attributes5 === void 0 ? void 0 : (_acfData$attributes5$ = _acfData$attributes5.language) === null || _acfData$attributes5$ === void 0 ? void 0 : (_acfData$attributes5$2 = _acfData$attributes5$[0]) === null || _acfData$attributes5$2 === void 0 ? void 0 : _acfData$attributes5$2.uri
    },
    languageClassCategory: (_acfData$attributes6 = acfData.attributes) === null || _acfData$attributes6 === void 0 ? void 0 : _acfData$attributes6.languageClassCategory
  }));
  var gallerySection = /*#__PURE__*/React.createElement(SectionWithTitle, {
    heading: pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf4 = pageTemplateData.acfProgramTemplate) === null || _pageTemplateData$acf4 === void 0 ? void 0 : (_pageTemplateData$acf5 = _pageTemplateData$acf4.gallerySection) === null || _pageTemplateData$acf5 === void 0 ? void 0 : _pageTemplateData$acf5.title,
    display: (_acfData$gallery = acfData.gallery) !== null && _acfData$gallery !== void 0 && (_acfData$gallery$yout = _acfData$gallery.youtubeLinks) !== null && _acfData$gallery$yout !== void 0 && _acfData$gallery$yout.length || (_acfData$gallery2 = acfData.gallery) !== null && _acfData$gallery2 !== void 0 && (_acfData$gallery2$med = _acfData$gallery2.medias) !== null && _acfData$gallery2$med !== void 0 && _acfData$gallery2$med.length ? 'flex' : 'none',
    mt: "0 !important",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(CarouselContainer, {
    interval: 100000,
    maxW: "100%"
  }, (_acfData$gallery3 = acfData.gallery) === null || _acfData$gallery3 === void 0 ? void 0 : (_acfData$gallery3$med = _acfData$gallery3.medias) === null || _acfData$gallery3$med === void 0 ? void 0 : _acfData$gallery3$med.map(function (media) {
    var _media$localFile;

    return /*#__PURE__*/React.createElement(Box, {
      position: "relative",
      key: media === null || media === void 0 ? void 0 : (_media$localFile = media.localFile) === null || _media$localFile === void 0 ? void 0 : _media$localFile.publicURL
    }, /*#__PURE__*/React.createElement(Image, {
      image: media,
      disableDrag: true
    }), /*#__PURE__*/React.createElement(Box, {
      width: "100%",
      h: "100%",
      position: "absolute",
      top: "0",
      left: "0",
      background: "linear-gradient(to bottom,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.6))"
    }), /*#__PURE__*/React.createElement(Text, {
      fontSize: "xl",
      color: "white",
      position: "absolute",
      fontWeight: "700",
      bottom: 3,
      left: "50%",
      transform: "translateX(-50%)",
      w: "100%",
      textAlign: "center"
    }, media === null || media === void 0 ? void 0 : media.description));
  })), /*#__PURE__*/React.createElement(CarouselContainer, {
    width: {
      base: 330,
      lg: '800px'
    }
  }, ((_acfData$gallery4 = acfData.gallery) === null || _acfData$gallery4 === void 0 ? void 0 : (_acfData$gallery4$you = _acfData$gallery4.youtubeLinks) === null || _acfData$gallery4$you === void 0 ? void 0 : _acfData$gallery4$you.length) && ((_acfData$gallery5 = acfData.gallery) === null || _acfData$gallery5 === void 0 ? void 0 : (_acfData$gallery5$you = _acfData$gallery5.youtubeLinks) === null || _acfData$gallery5$you === void 0 ? void 0 : _acfData$gallery5$you.map(function (youtubeLink) {
    return /*#__PURE__*/React.createElement(CarouselChild, {
      key: youtubeLink === null || youtubeLink === void 0 ? void 0 : youtubeLink.link,
      width: "100%"
    }, /*#__PURE__*/React.createElement(AspectRatio, {
      ratio: 16 / 9,
      width: {
        base: 330,
        lg: '800px'
      }
    }, /*#__PURE__*/React.createElement(Box, {
      as: "iframe",
      src: "https://youtube.com/embed/" + youtubeLink.link,
      allowFullScreen: true
    })));
  }))));
  var contactSection = /*#__PURE__*/React.createElement(SectionWithTitle, {
    heading: pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf6 = pageTemplateData.acfProgramTemplate) === null || _pageTemplateData$acf6 === void 0 ? void 0 : (_pageTemplateData$acf7 = _pageTemplateData$acf6.contactSection) === null || _pageTemplateData$acf7 === void 0 ? void 0 : _pageTemplateData$acf7.title,
    direction: {
      base: 'column',
      md: 'row'
    },
    justify: "center",
    bg: "secondary.500",
    my: "0 !important"
  }, pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf8 = pageTemplateData.acfProgramTemplate) === null || _pageTemplateData$acf8 === void 0 ? void 0 : (_pageTemplateData$acf9 = _pageTemplateData$acf8.contactSection) === null || _pageTemplateData$acf9 === void 0 ? void 0 : (_pageTemplateData$acf10 = _pageTemplateData$acf9.ctas) === null || _pageTemplateData$acf10 === void 0 ? void 0 : _pageTemplateData$acf10.map(function (cta) {
    var _cta$cta4;

    if ((cta === null || cta === void 0 ? void 0 : (_cta$cta4 = cta.cta) === null || _cta$cta4 === void 0 ? void 0 : _cta$cta4.label) === 'Demande de devis') {
      // if the program is available for online booking, then display the button
      return /*#__PURE__*/React.createElement(ButtonLink, {
        key: cta === null || cta === void 0 ? void 0 : cta.cta.label,
        cta: cta === null || cta === void 0 ? void 0 : cta.cta,
        state: {
          subject: 'devis'
        }
      });
    } else {
      var _cta$cta5;

      return /*#__PURE__*/React.createElement(ButtonLink, {
        key: cta === null || cta === void 0 ? void 0 : (_cta$cta5 = cta.cta) === null || _cta$cta5 === void 0 ? void 0 : _cta$cta5.label,
        cta: cta === null || cta === void 0 ? void 0 : cta.cta,
        color: "primary.500"
      });
    }
  }));
  var relatedProgramsSection = /*#__PURE__*/React.createElement(SectionWithTitle, {
    heading: pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf11 = pageTemplateData.acfProgramTemplate) === null || _pageTemplateData$acf11 === void 0 ? void 0 : (_pageTemplateData$acf12 = _pageTemplateData$acf11.relatedProgramsSection) === null || _pageTemplateData$acf12 === void 0 ? void 0 : _pageTemplateData$acf12.title
  }, /*#__PURE__*/React.createElement(Wrap, {
    justify: "center"
  }, (_acfData$relatedProgr = acfData.relatedPrograms) === null || _acfData$relatedProgr === void 0 ? void 0 : _acfData$relatedProgr.map(function (relatedProgram) {
    var _relatedProgram$acfPr, _relatedProgram$acfPr2, _relatedProgram$acfPr3, _relatedProgram$acfPr4, _relatedProgram$acfPr5, _relatedProgram$acfPr6, _relatedProgram$acfPr7, _relatedProgram$acfPr8, _relatedProgram$acfPr9, _relatedProgram$acfPr10, _relatedProgram$acfPr11, _relatedProgram$acfPr12, _relatedProgram$acfPr13, _relatedProgram$acfPr14;

    return /*#__PURE__*/React.createElement(WrapItem, {
      key: relatedProgram === null || relatedProgram === void 0 ? void 0 : relatedProgram.uri
    }, /*#__PURE__*/React.createElement(ProgramThumbnail, {
      bg: "primary.500",
      description: relatedProgram === null || relatedProgram === void 0 ? void 0 : (_relatedProgram$acfPr = relatedProgram.acfProgram) === null || _relatedProgram$acfPr === void 0 ? void 0 : (_relatedProgram$acfPr2 = _relatedProgram$acfPr.introduction) === null || _relatedProgram$acfPr2 === void 0 ? void 0 : _relatedProgram$acfPr2.shortIntroduction,
      image: relatedProgram === null || relatedProgram === void 0 ? void 0 : (_relatedProgram$acfPr3 = relatedProgram.acfProgram) === null || _relatedProgram$acfPr3 === void 0 ? void 0 : (_relatedProgram$acfPr4 = _relatedProgram$acfPr3.heroProgram) === null || _relatedProgram$acfPr4 === void 0 ? void 0 : _relatedProgram$acfPr4.mobileFeaturedImage,
      city: relatedProgram === null || relatedProgram === void 0 ? void 0 : (_relatedProgram$acfPr5 = relatedProgram.acfProgram) === null || _relatedProgram$acfPr5 === void 0 ? void 0 : (_relatedProgram$acfPr6 = _relatedProgram$acfPr5.introduction) === null || _relatedProgram$acfPr6 === void 0 ? void 0 : (_relatedProgram$acfPr7 = _relatedProgram$acfPr6.cityName) === null || _relatedProgram$acfPr7 === void 0 ? void 0 : (_relatedProgram$acfPr8 = _relatedProgram$acfPr7[0]) === null || _relatedProgram$acfPr8 === void 0 ? void 0 : _relatedProgram$acfPr8.title,
      country: relatedProgram === null || relatedProgram === void 0 ? void 0 : (_relatedProgram$acfPr9 = relatedProgram.acfProgram) === null || _relatedProgram$acfPr9 === void 0 ? void 0 : (_relatedProgram$acfPr10 = _relatedProgram$acfPr9.attributes) === null || _relatedProgram$acfPr10 === void 0 ? void 0 : (_relatedProgram$acfPr11 = _relatedProgram$acfPr10.country) === null || _relatedProgram$acfPr11 === void 0 ? void 0 : (_relatedProgram$acfPr12 = _relatedProgram$acfPr11[0]) === null || _relatedProgram$acfPr12 === void 0 ? void 0 : (_relatedProgram$acfPr13 = _relatedProgram$acfPr12.acfDestination) === null || _relatedProgram$acfPr13 === void 0 ? void 0 : (_relatedProgram$acfPr14 = _relatedProgram$acfPr13.heroDestination) === null || _relatedProgram$acfPr14 === void 0 ? void 0 : _relatedProgram$acfPr14.destinationName,
      uri: relatedProgram === null || relatedProgram === void 0 ? void 0 : relatedProgram.uri
    }));
  })));
  var testimonialBackgroundImageWithArtDirection = createImageWithArtDirection({
    desktopImage: pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf13 = pageTemplateData.acfProgramTemplate) === null || _pageTemplateData$acf13 === void 0 ? void 0 : (_pageTemplateData$acf14 = _pageTemplateData$acf13.testimonialsSectionLangue) === null || _pageTemplateData$acf14 === void 0 ? void 0 : _pageTemplateData$acf14.desktopBackgroundImage,
    mobileImage: pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf15 = pageTemplateData.acfProgramTemplate) === null || _pageTemplateData$acf15 === void 0 ? void 0 : (_pageTemplateData$acf16 = _pageTemplateData$acf15.testimonialsSectionLangue) === null || _pageTemplateData$acf16 === void 0 ? void 0 : _pageTemplateData$acf16.mobileBackgroundImage
  });
  return /*#__PURE__*/React.createElement(Layout, {
    currentLanguage: contentTypeData.language,
    currentPath: contentTypeData.link,
    menuData: pageContext.menus,
    siteSettings: pageContext.siteSettings,
    translations: contentTypeData.translations
  }, /*#__PURE__*/React.createElement(SEO, seoProps), /*#__PURE__*/React.createElement(Hero, {
    backgroundImage: imageWithArtDirection,
    couleurTitre: "#000",
    heading: (_acfData$introduction8 = acfData.introduction) === null || _acfData$introduction8 === void 0 ? void 0 : _acfData$introduction8.title,
    size: "short"
  }), introductionSection, informationsSection, gallerySection, contactSection, (_contentTypeData$acfP = contentTypeData.acfProgram) !== null && _contentTypeData$acfP !== void 0 && (_contentTypeData$acfP2 = _contentTypeData$acfP.testimonials) !== null && _contentTypeData$acfP2 !== void 0 && _contentTypeData$acfP2.length ? /*#__PURE__*/React.createElement(TestimonialsSection, {
    heading: pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf17 = pageTemplateData.acfProgramTemplate) === null || _pageTemplateData$acf17 === void 0 ? void 0 : (_pageTemplateData$acf18 = _pageTemplateData$acf17.testimonialsSectionLangue) === null || _pageTemplateData$acf18 === void 0 ? void 0 : _pageTemplateData$acf18.title,
    testimonials: (_contentTypeData$acfP3 = contentTypeData.acfProgram) === null || _contentTypeData$acfP3 === void 0 ? void 0 : _contentTypeData$acfP3.testimonials,
    backgroundImage: testimonialBackgroundImageWithArtDirection,
    mt: "0 !important"
  }) : null, relatedProgramsSection);
};

export default ProgrammeTemplate;
var query = "2817521572";